import * as React from 'react';

import { GuideBox } from '../elements/GuideBox';
import { GuideButton } from '../elements/GuideButton';

interface IProps {
  onCancel: () => void;
  onStage: (s: string) => void;
}

const NavigationGuide = (props: IProps) => {
  return (
    <GuideBox top="32px" right="60px" onCancel={props.onCancel}>
      <h1>Navigation</h1>
      <p><em>You can pan, zoom, rotate and tilt the map.</em></p>
      <p>Click (and hold) and drag the map to <b>pan</b> it.</p>
      <GuideButton onClick={() => props.onStage('zooming')}>Continue</GuideButton>
    </GuideBox>
  );
}

export { NavigationGuide }
